import theme from '../../../../lib/theme';

const {
  layouts,
  scale,
  media,
} = theme;

export default () => ({
  ad: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'min-height 1s ease-in-out',
    position: 'relative', // Add this to correctly position the inner text
    marginTop: '15px',

    '& > div': {
      zIndex: '1', // Ensure ad content is above the pseudo-elements
      backgroundColor: '#fff',
    },

    '&:after': {
      content: '"-Advertisement-"',
      position: 'absolute',
      top: '-15px',
      display: 'block',
      fontSize: '0.7em',
      color: 'rgba(102, 102, 102, 0.7)',
      textAlign: 'center',
    },

    '&:before': {
      content: '"-Advertisement loading-"',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#999',
      fontSize: '12px',
      zIndex: '0',
    },
  },
	layoutColumns: {
		gap: '1em',

		'> div': {
			width: `100%`,
			maxWidth: `100%`,

      '&.column-0': {
        flex: `1 0 calc(800px - 1em)`, 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1em',
      },

			[media.xl.down]: {
        // width: `100%!important`,
				// maxWidth: `100%!important`,
			}
		},
    
		[media.xl.down]: {
      flexDirection: 'column',
      
      '> div.column-0': {
        flex: 'auto!important',
      }
		}
	},

  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,
    margin: `0 auto`,
    
    [media.xxl.up]: {
      padding: `0`,
    },
  },

  columns: {
    ...layouts.column,

    '& > *': {
      marginBottom: scale.m,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'stretch',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.m,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },
  articleBlockSidebar: {
    display: 'none',
    flexDirection: 'column',
    gap: '0.5em',
    position: 'relative',
    justifyContent: 'flex-start',
    
    [media.xl.up]: {
      flex: `0 0 300px`,
      display: 'flex',
    },
  },

  articleBlockSidebarContainer: {
    position: 'sticky',
    top: '10px',
    gap: '0.5em',
  }
});
